import React, { Component } from 'react'

import { css } from '@emotion/core'

// Another way to import. This is recommended to reduce bundle size
import DotLoader from 'react-spinners/ClipLoader'

export class Modals extends Component {
  render() {
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `

    let rejectContent = ''
    let returnContent = ''
    let approveContent = ''
    let transmitContent = ''
    let reviewContent = ''
    let onHoldContent = ''

    if (this.props.onHoldRequest === true) {
      onHoldContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>On Hold</h4>
          <form action=''>
            <div className='returnLabel'>
              <p>Message:</p>
              <small id='returnValidation'></small>
            </div>
            <textarea
              name='reason'
              id='returnMessage'
              onChange={this.props.handleChangeState}
            ></textarea>
            <div className='modalBtnContainer'>
              <button
                type='button'
                className='cancelModalBtn'
                onClick={this.props.closeReturnModal}
              >
                CANCEL
              </button>
              <button
                type='button'
                className='returnBtnDept'
                onClick={this.props.handleOnHold}
              >
                CONFIRM
              </button>
            </div>
          </form>
        </div>
      )
    }

    if (this.props.endorseRequest === true) {
      reviewContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>In Process</h4>
          <div id='approveMessage'>
            <h5>
              You are about to mark this request as In Process. Please confirm.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              //href={this.props.crfLink}
              className='returnBtnDept'
              onClick={this.props.handleInprocess}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.reviewRequest === true) {
      reviewContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Mark as Reviewed</h4>
          <div id='approveMessage'>
            <h5>
              You are about to mark this request as reviewed which means that
              you will become liable in the process flow.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              type='button'
              className='returnBtnDept'
              onClick={this.props.handleReviewed}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.transmitRequest === true) {
      transmitContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Mark as Transmitted</h4>
          <div id='approveMessage'>
            <h5>
              You are about to mark this request as transmitted which means that
              you will become liable in the process flow. Please make sure that
              you already have the hard copy of the documents to be reviewed.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              type='button'
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              type='button'
              className='returnBtnDept'
              onClick={this.props.handleTransmitted}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.rejectRequest === true) {
      returnContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Reject This Request</h4>
          <form action=''>
            <div className='returnLabel'>
              <p>Reason:</p>
              <small id='returnValidation'></small>
            </div>
            <textarea
              name='reason'
              id='returnMessage'
              onChange={this.props.handleChangeState}
            ></textarea>
            <div className='modalBtnContainer'>
              <button
                className='cancelModalBtn'
                onClick={this.props.closeReturnModal}
              >
                CANCEL
              </button>
              <button
                type='button'
                className='returnBtnDept'
                onClick={this.props.handleRejectRequest}
              >
                REJECT
              </button>
            </div>
          </form>
        </div>
      )
    }

    if (this.props.returnRequest === true) {
      returnContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Returning a Request</h4>
          <form action=''>
            <div className='returnLabel'>
              <p>Reason:</p>
              <small id='returnValidation'></small>
            </div>
            <textarea
              name='reason'
              id='returnMessage'
              onChange={this.props.handleChangeState}
            ></textarea>
            <div className='modalBtnContainer'>
              <DotLoader
                css={override}
                size={50}
                //size={"150px"} this also works
                color={'#123abc'}
                loading={this.props.loading}
              />
              <button
                className='cancelModalBtn'
                onClick={this.props.closeReturnModal}
              >
                CANCEL
              </button>
              <button
                type='button'
                className='returnBtnDept'
                onClick={this.props.handleReturnRequest}
              >
                CONFIRM
              </button>
            </div>
          </form>
        </div>
      )
    }

    if (this.props.approveRequest === true) {
      approveContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Approve Request</h4>
          <div id='approveMessage'>
            <h5>
              You are about to approve this request. Please make sure that you
              already reviewed the request.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              className='returnBtnDept'
              onClick={this.props.handleApproveCrf}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.compApproveRequest === true) {
      approveContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Approve Request</h4>
          <div id='approveMessage'>
            <h5>
              You are about to approve this request. Please make sure that you
              already reviewed the request.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              className='returnBtnDept'
              onClick={this.props.handleCompApproveCrf}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.cooApproveRequest === true) {
      approveContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>Approve Request</h4>
          <div id='approveMessage'>
            <h5>
              You are about to approve this request. Please make sure that you
              already reviewed the request.
            </h5>
          </div>
          <div className='modalBtnContainer'>
            <button
              className='cancelModalBtn'
              onClick={this.props.closeReturnModal}
            >
              CANCEL
            </button>
            <button
              className='returnBtnDept'
              onClick={this.props.handleCooApproveCrf}
            >
              CONFIRM
            </button>
          </div>
        </div>
      )
    }

    if (this.props.editCrfDetails === true) {
      approveContent = (
        <div className='modalContent'>
          <h4 className='returnHeader'>edit Details Request</h4>
        </div>
      )
    }

    return (
      <div id='modalBody' className='modalBody'>
        <div className='modalContainer'>
          <div className='modalbg' onClick={this.props.closeReturnModal}></div>
          {returnContent}
          {approveContent}
          {rejectContent}
          {transmitContent}
          {reviewContent}
          {onHoldContent}
        </div>
      </div>
    )
  }
}

export default Modals
